import { CotopaxiPaddings } from './CommonTypes';
import { ImagePathWithRenditions } from './ImageTypes';

export type AccountTitle = {
  show: boolean;
  value?: string;
};

export type AccountMenuItem = {
  label: string;
  link: string;
  active: boolean;
  hideForGuest: boolean;
};

export type AccountMenuProps = {
  hideOnMobile: boolean;
  items: Array<AccountMenuItem>;
  timestamp: number;
  title: AccountTitle;
};

export type AccountOverviewInfoContainerProps = {
  editProfileLink: string;
  title: AccountTitle;
};

export type AccountVouchersContainerProps = {
  title: AccountTitle;
};

export type AccountPasswordResetContainerProps = {
  title: AccountTitle;
};

export type AccountActivationContainerProps = {
  title: AccountTitle;
};

export type AccountCreditCardContainerProps = {
  title: AccountTitle;
};

export type AccountDeliveryAddressesContainerProps = {
  editProfileLink: string;
  accountAddressTitle: AccountTitle;
  deliveryAddressTitle: AccountTitle;
};

export type AccountOrderHistoryContainerProps = {
  showMoreUrl: string;
  showMoreLabel?: string;
  title: AccountTitle;
};

export type AccountProfileDetailsContainerProps = {
  showAddress: boolean;
  showDateOfBirth: boolean;
  showDepartmentName: boolean;
  showInvoiceCheckbox: boolean;
  showMobilePhoneNumber: boolean;
  title: AccountTitle;
};

export type AccountEnrichmentContainerProps = {
  enableAddressField?: boolean;
  enableBirthdayDescriptionField?: boolean;
  enableBirthdayField?: boolean;
  enableEmailAddressField?: boolean;
  enableInvoiceDepartmentNameFields?: boolean;
  enableInvoiceDetailFields?: boolean;
  enablePhoneNumberField?: boolean;
  enablePreferredLanguageField?: boolean;
  saveButtonText?: string;
  successMessageText?: string;
  componentTitle?: string;
  successRedirectPage?: string;
};

export type AccountPaybackEnrichmentProps = {
  confirmationUrl?: string;
  image?: ImagePathWithRenditions;
};

export type AccountPreferencesContainerProps = {
  items: Array<PreferenceItemConfig>;
  topText?: string;
  bottomText?: string;
  pathPrivacy?: string;
  pathTerms?: string;
  title: AccountTitle;
};

export type AccountUnsubscribeContainerProps = {
  label?: string;
  showCancel: boolean;
  newsletters?: PreferenceItemConfig;
};

export enum PreferenceTypes {
  ETICKET = 'eticket',
}

export type PreferenceSubNewsletterItem = {
  description: string;
  title: string;
  type: string;
};

export type PreferenceItemConfig = {
  checkboxLabel: string;
  type: string;
  preferenceText?: string;
  subNewsletters?: Array<PreferenceSubNewsletterItem>;
};

export type Preferences = {
  advice_newsletter: boolean;
  allowed_to_phone: boolean;
  catalog_requested: boolean;
  email_newsletter: boolean;
  events_newsletter: boolean;
  mail_basket: boolean;
  mail_review: boolean;
  partner_newsletter: boolean;
  physical_newsletter: boolean;
  promotion_newsletter: boolean;
};

export type PreferenceListItem = {
  code: string;
  doubleOptinConfirmed: boolean;
  doubleOptinEnabled: boolean;
  doubleOptinMailSent: boolean;
  isSubscribed: boolean;
  sortOrder: number;
  parentPreferenceFlagCode: string;
};

export type PreferencesByFascia = {
  fasciaId: number;
  sortOrder: number;
  preferenceList: Array<PreferenceListItem>;
  preferences: Array<Preferences>;
};

export type MultiFasciaPreferences = {
  eticket: boolean;
  fascias: Array<PreferencesByFascia>;
};

export type CustomerNewsletterPreferences = {
  businessUnitId: number;
  currentEmailOptin: boolean;
  customerIdentityId: string;
  defaultEmailOptin: boolean;
  fasciaId: number;
  hasPassword: boolean;
  hasSocialMediaAccountLinked: boolean;
  marketId: number;
  newCustomer: boolean;
};

export type ChangePasswordContainerProps = {
  title: AccountTitle;
};

export type AccountMenuItemContainerProps = {
  accountMenu: {
    items: [
      {
        label: string;
        link: string;
        active: boolean;
      },
    ];
  };
  login: {
    actionUri: string;
  };
  registration: {
    link: string;
  };
};

export type AccountRegistrationContainerProps = {
  title?: string;
  image?: ImagePathWithRenditions;
  introText?: string;
  showDateOfBirth?: boolean;
  showMobilePhoneNumber?: boolean;
  showAddress?: boolean;
  showInvoiceCheckbox?: boolean;
  showDepartmentName?: boolean;
  showNewsletterCheckbox?: boolean;
  redirectUrl?: string;
};

export type RegistrationCompactContainerProps = {
  paddings?: CotopaxiPaddings;
  title?: string;
  image?: ImagePathWithRenditions;
  registrationRedirectUrl: string;
};

export enum UserVisibility {
  AUTHORIZED = 'authorized',
  AUTHORIZED_AND_SOFT_LOGGED_IN = 'authorized_and_soft_logged_in',
  EVERYONE = 'everyone',
}

export type GuestRedirectContainerProps = {
  visibility: UserVisibility;
};
